import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const OneColumnDataDisplayRow = memo(({ title, value }) => {
    return (
        <Row>
            {title}: <Span>{value}</Span>
        </Row>
    );
});

OneColumnDataDisplayRow.displayName = 'OneColumnDataDisplayRow';
OneColumnDataDisplayRow.propTypes = {
    title: PropTypes.string,
    value: PropTypes.any
};

const Row = styled.div`
    margin-bottom: 8px;
`;

const Span = styled.span`
    color: black;
`;
